import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('TimeDisplay').create(({ theme }) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
  },

  separator: {
    color: theme.colors.text.secondary,
    fontSize: '20px',
    fontFamily: 'Space Grotesk',
  },

  digitContainer: {
    position: 'relative',
    width: '24px',
    height: '30px',
    overflow: 'hidden',
    backgroundColor: 'rgba(19, 21, 31, 1)',
    borderRadius: '4px',
    boxShadow: '0px 1px 0px 0px rgba(50, 71, 94, 1), 0px 1px 0px 0px rgba(0, 0, 0, 1) inset',
  },

  digit: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.colors.text.primary,
    fontFamily: 'Space Grotesk',
    fontSize: '18px',
    transition: 'transform 0.5s ease-in-out',
  },

  currentNumber: {
    transform: 'translateY(0%)',
  },

  nextNumber: {
    transform: 'translateY(-100%)',
  },

  animatingCurrentNumber: {
    transform: 'translateY(100%)',
  },

  animatingNextNumber: {
    transform: 'translateY(0%)',
  },
}))
